export enum HostTypes {
  Android = "Android",
  iOS = "iOS",
  WeChat = "WeChat",
}


